import { withSvgIcon } from './withSvgIcon';

export const Refresh = withSvgIcon(
  <>
    <path
      d="M15 9L18 6L15 3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M9 15L6 18L9 21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M17 6H9C5.68629 6 3 8.68629 3 12C3 12.7013 3.12031 13.3744 3.34141 14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M7 18L15 18C18.3137 18 21 15.3137 21 12C21 11.2987 20.8797 10.6256 20.6586 10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </>,
);
